const tiposPorcentajesIVA = [
  { codigo: 0, nombre: "0" },
  { codigo: 5, nombre: "5" },
  { codigo: 16, nombre: "16" },
  { codigo: 19, nombre: "19" },
];

export default tiposPorcentajesIVA;
